import Image from 'next/image'
import PlayArrowRoundedSvg from '@/components/icons/play-arrow-rounded'

const StepArrow = <div className="self-center"><PlayArrowRoundedSvg /></div>

export default function ForProProcess() {
  return (
    <div className="container">
      <h2 className="mb-15 text-center text-2xl lg:text-3xl font-medium">
        ご依頼受注の流れ
      </h2>
      <div className="noscrollbar -mx-5 mb-14 flex flex-row space-x-3 overflow-auto px-5 lg:mb-0 lg:block lg:space-x-0">
        <div className="flex items-stretch justify-center space-x-3 lg:mb-14">
          <article className="relative flex w-80 flex-col items-center justify-start space-y-4 pt-7">
            <div className="absolute top-0 left-0">
              <div className="inspiration inline-block gradient-b bg-clip-text text-6xl text-transparent">
                Step1
              </div>
            </div>
            <Image
              src="/images/service/detail/step-1.png"
              alt=""
              width={140}
              height={140}
            />
            <h3 className="text-xl font-medium">プロフィール・実績を登録する</h3>
            <div className="text-ghost text-sm">
              得意なジャンルやスキル、過去の制作実績を登録します。審査を経て、クリエイターとしてページが公開されます。
            </div>
          </article>
          {StepArrow}
          <article className="relative flex w-80 flex-col items-center justify-start space-y-4 pt-7">
            <div className="absolute top-0 left-0">
              <div className="inspiration inline-block gradient-b bg-clip-text text-6xl text-transparent">
                Step2
              </div>
            </div>
            <Image
              src="/images/service/detail/step-2.png"
              alt=""
              width={140}
              height={140}
            />
            <h3 className="text-center text-xl font-medium">
              公開依頼に提案する
            </h3>
            <div className="text-ghost text-sm">
              クライアントが投稿した依頼を見て、興味のある案件に自分から提案できます。
            </div>
          </article>
          {StepArrow}
          <article className="relative flex w-80 flex-col items-center justify-start space-y-4 pt-7">
            <div className="absolute top-0 left-0">
              <div className="inspiration inline-block gradient-b bg-clip-text text-6xl text-transparent">
                Step3
              </div>
            </div>
            <Image
              src="/images/service/detail/step-3.png"
              alt=""
              width={140}
              height={140}
            />
            <h3 className="text-center text-xl font-medium">
              クライアントから直接相談が届く
            </h3>
            <div className="text-ghost text-sm">
              あなたのプロフィールを見たクライアントから、直接相談が届くこともあります。
            </div>
          </article>
        </div>
        <div className="flex items-stretch justify-center space-x-3 lg:mb-14">
          {StepArrow}
          <article className="relative flex w-80 flex-col items-center justify-start space-y-4 pt-7">
            <div className="absolute top-0 left-0">
              <div className="inspiration inline-block gradient-b bg-clip-text text-6xl text-transparent">
                Step4
              </div>
            </div>
            <Image
              src="/images/service/detail/step-4.png"
              alt=""
              width={140}
              height={140}
            />
            <h3 className="text-center text-xl font-medium">
              見積もり合意後、クライアントが事前支払い
            </h3>
            <div className="text-ghost text-sm">
              クライアントと内容をすり合わせ、見積もりに合意をもらったらクライアントがお支払い。プロジェクト開始です。
            </div>
          </article>
          {StepArrow}
          <article className="relative flex w-80 flex-col items-center justify-start space-y-4 pt-7">
            <div className="absolute top-0 left-0">
              <div className="inspiration inline-block gradient-b bg-clip-text text-6xl text-transparent">
                Step5
              </div>
            </div>
            <Image
              src="/images/service/detail/step-5.png"
              alt=""
              width={140}
              height={140}
            />
            <h3 className="text-center text-xl font-medium">
              制作・納品する
            </h3>
            <div className="text-ghost text-sm">
              クライアントと直接やりとりしながら制作を進めます。納品後、クライアントの確認が取れたらプロジェクト完了です。
            </div>
          </article>
          {StepArrow}
          <article className="relative flex w-80 flex-col items-center justify-start space-y-4 pt-7">
            <div className="absolute top-0 left-0">
              <div className="inspiration inline-block gradient-b bg-clip-text text-6xl text-transparent">
                Step6
              </div>
            </div>
            <Image
              src="/images/service/detail/step-5.png"
              alt=""
              width={140}
              height={140}
            />
            <h3 className="text-center text-xl font-medium">
              報酬を受け取る
            </h3>
            <div className="text-ghost text-sm">
              プロジェクトが完了したら、報酬が口座に入金されます。（サービス手数料20%）
            </div>
          </article>
        </div>
      </div>
    </div>
  )
}
